<template>
  <div class="table__row" :class="{ isActive: data.active }">
    <div
      class="table__col"
      v-for="column in columns"
      :key="column.key"
      :style="column.style"
      :class="column.class"
    >
      <slot v-if="column.slot" :name="column.dataIndex" :item="data" />
      <p v-else>{{ data[column.dataIndex] }}</p>
    </div>
    <div
      class="table__popover"
      :class="{ '--top': index > 9, '--bottom': index <= 9 }"
      :id="`popover${data.id}`"
      popover
    >
      <slot name="popover" :item="data" />
    </div>
  </div>
</template>

<script>
import { watch } from "vue";

export default {
  props: {
    data: Object,
    columns: Array,
    index: Number,
  },
  setup(props, { emit }) {

    watch(props.data, () => {
      let data = JSON.parse(JSON.stringify(props.data));
      data.active = true;
      emit("change", data)
    });

    return {};
  },
};
</script>

<style scoped>
p {
  margin: 0;
}
.table__row {
  position: relative;
  display: flex;
  border-bottom: 1px solid rgb(214, 214, 214);
}
.table__col {
  width: 150px;
  height: 50px;
  display: flex;
  align-items: center;
  padding: 10px;
  overflow: hidden;
}
.table__popover {
  position: absolute;
  display: none;
  background-color: #fff;
  border: 1px solid blue;
  padding: 5px;
  z-index: 10;
}
.table__popover.--top {
  bottom: 100%;
}
.table__popover.--bottom {
  top: 100%;
}
.open_popover:hover ~ .table__popover {
  display: block;
}
.table__popover:hover {
  display: block;
}
.isActive {
  @apply bg-gray-300;
}
</style>
